export function initDataLayer() {
    window.dataLayer = window.dataLayer || [];
}
